import React, {useMemo} from "react";
import {useSelector} from "react-redux";
import {RootStore} from "../../../../configureStore";
import FieldWrapper from "../FieldWrapper";
import IntakeMonth from "./IntakeMonth";

const IntakeMonthWrapper: React.FC = () => {
    const intakeMonth = useSelector(
        (state: RootStore) => state.RegistrationLoginPage.signUpPageData?.fields?.intakeMonth,
    );

    return useMemo(() => {
        if (intakeMonth) {
            return (
                <FieldWrapper visible={intakeMonth.visible} loading={intakeMonth.loading ?? false}>
                    <IntakeMonth
                        fieldName={intakeMonth.fieldName}
                        values={intakeMonth.values}
                        selectedValue={intakeMonth.selectedValue}
                        editable={intakeMonth.editable}
                    />
                </FieldWrapper>
            );
        }
        return null;
    }, [intakeMonth]);
};
export default IntakeMonthWrapper;
